exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */:host{line-height:1.85rem}.ngb-dp-arrow,:host{height:2rem;display:-ms-flexbox;display:flex}.ngb-dp-arrow{-webkit-box-flex:1 1 auto;-ms-flex:1 1 auto;-ms-flex-preferred-size:auto;flex-basis:auto;-ms-flex-positive:1;flex-grow:1;width:2rem}[dir] .ngb-dp-arrow{margin:0}[dir=ltr] .ngb-dp-arrow,[dir=rtl] .ngb-dp-arrow{padding-right:0;padding-left:0}.ngb-dp-arrow.right{-ms-flex-pack:end;justify-content:flex-end}[dir] .ngb-dp-arrow-btn{padding:0 1rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker-navigation.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker-navigation.component.scss
// module chunks = 0